// layout
import DefaultLayout from "src/layouts/DefaultLayout/DefaultLayout"
// components
import { ContentWrapper, HeaderWrapper } from "@components/Common"
import { ReportPageContent, ReportPageHeader } from "@components/ReportPage"

const ReportsPage = () => {
    return (
        <DefaultLayout contentClassName="gap-5 lg:gap-6 3xl:gap-8">
            <HeaderWrapper className="md:items-start">
                <ReportPageHeader />
            </HeaderWrapper>
            <ContentWrapper className="px-5 lg:px-10 xl:px-16 2xl:px-20">
                <ReportPageContent />
            </ContentWrapper>
        </DefaultLayout>
    )
}

export default ReportsPage
